export function formatCoins(coins) {
    return reverseString(reverseString(String(coins)).replace(/(\d{3})/g, '$1 ')).trim();
}
export function reverseString(str) {
    return str.split('').reverse().join('');
}
// console.log('formatCoins:', formatCoins(1000))
// console.log('formatCoins:', formatCoins(10000))
// console.log('formatCoins:', formatCoins(100000))
// console.log('formatCoins:', formatCoins(1000000))
// console.log('formatCoins:', formatCoins(10000000))
